<template>

  <div
    class="modal adapted-meet-max-width"
    tabindex="-1"
    role="dialog">
    <div
      class="modal-dialog"
      role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('Export') }}</h5>
          <!-- <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="show=false">
            <span aria-hidden="true">&times;</span>
          </button> -->
        </div>
        <div class="modal-body">

          <form
            id="export"
            v-if="!create"
            v-on:submit.prevent="exportFile">
            <div class="form-group">
              <label>{{ $t('File type') }}</label>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  id="radio-csv"
                  value="csv"
                  v-model="file_type">
                <label
                  class="form-check-label"
                  for="radio-csv">
                  CSV
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  id="radio-xlsx"
                  value="xlsx"
                  v-model="file_type">
                <label
                  class="form-check-label"
                  for="radio-xlsx">
                  Excel
                </label>
              </div>
            </div>
          </form>

          <div v-if="create">
            <a
              v-if="isCompleted"
              class="btn btn-primary"
              :href="dataimex.url">
              <i class="fas fa-download" /> {{ $t('Download') }}
            </a>
            <div
              v-if="!isCompleted"
              class="spinner-border"
              role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            v-if="!create"
            type="submit"
            class="btn btn-primary"
            form="export">Exportar</button>
          <button
            type="button"
            class="btn btn-light"
            @click="close">{{ $t('Cancel') }}</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'DataimexModal',
  props: {
    promise: {
      type: Function
    }
  },
  components: {
  },
  data () {
    return {
      create: false,
      loading: true,
      file_type: 'csv',
      dataimex: {},
      interval: false
    }
  },
  computed: {
    isCompleted () {
      return this.dataimex.status === 'complete' && this.dataimex.url
    }
  },
  created () {
  },
  destroyed () {
    this.removeInterval()
  },
  methods: {
    removeInterval () {
      clearInterval(this.interval)
    },
    createInterval () {
      clearInterval(this.interval)
      this.$store.dispatch('getDataimexById', this.dataimex._id).then(result => {
        this.dataimex = result
        if (result.status === 'complete') {
          this.removeInterval()
        } else {
          this.interval = setTimeout(this.createInterval, 5000)
        }
      })
    },
    close () {
      this.$emit('close')
    },
    exportFile () {
      this.create = this.loading = true
      this.promise(this.file_type).then(res => {
        this.loading = false
        this.dataimex = res.data
        this.createInterval()
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal{
  display: block;
  background: rgb(0,0,0,0.7);
  padding: 20px;
}
</style>





// WEBPACK FOOTER //
// src/components/Dataimex/DataimexExportModal.vue